import React from 'react';
import { useParams } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import {   Container, Typography } from '@mui/material';

// components
import Page from '../../components/Page';
// import { MHidden } from '../../../components/@material-extend';
import  ActivateForm  from './activateform';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

// const SectionStyle = styled(Card)(({ theme }) => ({
//   width: '100%',
//   maxWidth: 464,
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   margin: theme.spacing(2, 0, 2, 2)
// }));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------
export default function Reset() {
 let { authcode } = useParams();
  //console.log(authcode)
    return (
      <RootStyle title="Reset Password | Astro POS">

        <Container maxWidth="sm">
                  <ContentStyle className="mobileminauto">

                  <Typography style={{  maxWidth:'480px'}}>
                      <img alt="Astro POS" src="/static/icons/logo-450.png"  className='logoimg'
                                        style={{ objectFit: 'cover', maxWidth:'100%'}}/>
                    </Typography>
                  </ContentStyle>
          </Container>
        <Container maxWidth="sm">
          <ContentStyle>

        <ActivateForm authcode={authcode}/>
          </ContentStyle>
        </Container>
      </RootStyle>
    );
}
